// Article-level TR <-> EN counterparts.
//
// hreflang must be reciprocal AND slug-accurate: /yazilar/<tr-slug> and
// /ideas/<en-slug> use different slugs, so a mechanical prefix rewrite would
// produce 404s. Keep this table in sync with `turkishHref` in
// src/content/en/ideas*(.ts) — it is the light, client-safe mirror of it so
// the language switcher does not have to bundle every English essay body.
//
// An article without an entry here has no counterpart: emit no alternate link
// and send the language switcher to the section root instead of a dead URL.

/** [Turkish article slug, English idea slug] */
export const ARTICLE_PAIRS: ReadonlyArray<readonly [string, string]> = [
  ["gelecegi-kim-yagmaladi", "who-plundered-the-future"],
  ["yalnizlik-a-s", "the-loneliness-economy"],
  ["surdurulebilirlik-nedir-bir-elestiri", "what-is-sustainability-a-critique"],
  ["iklim-krizinin-onundeki-en-buyuk-engel-beynimiz", "the-biggest-obstacle-to-the-climate-crisis-is-our-brain"],
  ["surdurulebilirlik-fetisi-elestirel-bir-perspektif", "the-sustainability-fetish-a-critical-perspective"],
  ["verimlilik-maskeli-obur", "efficiency-a-glutton-in-disguise"],
  ["ozgur-irade", "free-will-or-algorithmic-surrender"],
  ["yesil-aklama-artik-ahlak-degil-ispat-meselesi", "greenwashing-is-now-a-matter-of-proof"],
  ["yapay-cazibe-ile-cozulen-muhakeme", "judgment-dissolved-by-artificial-charm"],
  ["surdurulebilirlik-sektoru-krizden-kar-saglamak", "profiting-from-the-crisis"],
  ["yapay-zeka-ayrimi-yeni-bir-buyuk-ayrisma-yaklasiyor", "the-coming-ai-divide"],
  ["dijital-cagin-enerji-ikilemi", "the-energy-dilemma-of-the-digital-age"],
  ["golgenin-fiyati", "the-price-of-shade"],
  ["hakikat-ve-guven-bilginin-savas-alani", "truth-and-trust-the-battlefield-of-knowledge"],
];

const strip = (s: string) => s.replace(/\/+$/, "");

/** /yazilar/<tr-slug> -> /ideas/<en-slug>, or null when there is no counterpart. */
export function enArticlePath(trPath: string): string | null {
  const clean = strip(trPath);
  const slug = clean.startsWith("/yazilar/") ? clean.slice("/yazilar/".length) : null;
  if (!slug) return null;
  const pair = ARTICLE_PAIRS.find(([tr]) => tr === slug);
  return pair ? `/ideas/${pair[1]}` : null;
}

/** /ideas/<en-slug> -> /yazilar/<tr-slug>, or null when there is no counterpart. */
export function trArticlePath(enPath: string): string | null {
  const clean = strip(enPath);
  const slug = clean.startsWith("/ideas/") ? clean.slice("/ideas/".length) : null;
  if (!slug) return null;
  const pair = ARTICLE_PAIRS.find(([, en]) => en === slug);
  return pair ? `/yazilar/${pair[0]}` : null;
}
